var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractEffector, Effect } from './IEffector';
/**
 * some(where(p.eft == allow))
 */
var DefaultEffector = /** @class */ (function (_super) {
    __extends(DefaultEffector, _super);
    function DefaultEffector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultEffector.prototype, "effector", {
        // private eft: jsep.Expression;
        get: function () {
            return this._effector;
        },
        enumerable: true,
        configurable: true
    });
    DefaultEffector.prototype.setEffector = function (expr) {
        this._effector = expr.replace(/^e ?= ?/, '');
        // this.eft = jsep(expr);
    };
    DefaultEffector.prototype.isEffect = function (matched) {
        return some(where(function (_, eft) { return eft === Effect.Allow; }))(matched.policyEffects);
    };
    return DefaultEffector;
}(AbstractEffector));
export { DefaultEffector };
export function some(predicate) {
    return function (collections) {
        return collections.some(function (data) { return predicate(collections, data).length > 0; });
    };
}
export function where(predicate, limit) {
    if (limit === void 0) { limit = -1; }
    return function (collections) {
        var results = collections.filter(function (data) { return predicate(collections, data); });
        if (limit < 0) {
            return results;
        }
        return results.slice(0, limit);
    };
}
